import Moment from 'moment';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { FormInputProps } from './Form.types';

const format = 'h:mm a';
const now = Moment().hour(0).minute(0);

function Requirement({ isHidden, text }: { isHidden: boolean; text: string }) {
  const className = `requirement${isHidden === true ? '' : '-showing'}`;
  return <div className={className}>{text}</div>;
}

function FormInput({
  onClick,
  route,
  successActions,
  classNameOverride,
  label,
  title,
  errorMessage,
  rowClassName,
  options,
  placeholder,
  element,
  id,
  required,
  validation,
  value,
  isDisabled,
  type,
  formInputOnChange,
  multiSelectEnabled,
  onClickWrapper,
}: FormInputProps) {
  const startDate = new Date();

  /*
    let value = props.value;
         if(props.data.type === 'checkbox')
         {
           value = props.data.checked;
         }
         else if(props.data.type === 'select' && props.data.multiSelectEnabled)
         {
           value = Array.isArray(props.data.value) ? props.data.value : [props.data.value];
         }

         */
  const [isFocused, setIsFocused] = useState<boolean>(false);

  // MARK: - Event handlers
  // Update parent
  const onChange = (evt: any) => {
    let value = type === 'file' ? evt.target.files[0] : evt.target ? evt.target.value : evt;
    if (type === 'checkbox') {
      value = !!evt.target.checked;
    } else if (type === 'select' && multiSelectEnabled) {
      value = [];
      for (let i = 0; i < evt.target.options.length; i++) {
        /* Go through options list and add selected to list
              but if the value in the event matches then we
              clicked a selected value and should unselect it   */
        if (evt.target.options[i].selected) {
          value.push(evt.target.options[i].value);
        }
      }
    }

    // Notify form (parent)
    formInputOnChange({
      id,
      value,
      validation,
      type,
    });
  };
  const onFocus = () => setIsFocused(true);
  const onFocusOut = () => setIsFocused(false);

  // Requirement
  const requirement = validation && validation.requirement ? validation.requirement : '';
  let requirementDivIsHidden = true;

  if (id === 'airtableBaseId') {
    console.log('airtableBaseId', errorMessage);
  }
  // Class name
  let className = classNameOverride || '';
  if (errorMessage === '' || errorMessage === undefined) {
    try {
      // No error and value input so show valid
      if (value && value.length > 0) {
        className += 'valid';
      } else if (value && !Number.isNaN(value)) {
        className += 'valid';
      } else if (value === 0 && type === 'number') {
        className += 'valid';
      } else {
        //  console.log(id + '? Curious functionality');
      }
      if (id === 'airtableBaseId') {
        console.log('airtableBaseId', className);
      }
    } catch (err) {
      console.log(err);
      console.log(id);
    }
  } else {
    // Show requirement div  if error message
    if (errorMessage !== '-EV') {
      // If field not in focus show it as pink
      if (!isFocused) {
        className += 'invalid';
      }
      // Otherwise show requirement text
      else {
        requirementDivIsHidden = false;
      }
    }
  }

  const onClickWrapperInternal = (e: any) => {
    if (onClickWrapper && onClick) {
      e.preventDefault();
      if (type === 'button') {
        onClickWrapper && onClick && onClickWrapper(onClick, e, { route, successActions });
      } else {
        onClickWrapper && onClick && onClickWrapper(onClick, e);
      }
    }
  };

  const formInput =
    (element === 'select' && (
      <div className="dropdown">
        <select
          id={id}
          value={value !== undefined ? value : ''}
          onChange={onChange}
          onClick={onClickWrapperInternal}
          key={id}
          multiple={multiSelectEnabled}
          className={className}
          disabled={isDisabled}
          required={!!required}
          onFocus={onFocus}
          onBlur={onFocusOut}>
          {!multiSelectEnabled && (
            <option key="defaultRow" value="">
              Click to see options
            </option>
          )}
          {options?.map(entry => (
            <option key={entry.value} value={entry.value}>
              {entry.text}
            </option>
          ))}
        </select>
      </div>
    )) ||
    (element === 'time' && (
      <TimePicker
        showSecond={false}
        defaultValue={now}
        className=""
        onChange={onChange}
        format={format}
        use12Hours
      />
    )) ||
    (element === 'datetime' && (
      <DatePicker
        selected={value ? new Date(value) : startDate}
        onChange={onChange}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={15}
        timeCaption="time"
        dateFormat="MMMM d, yyyy h:mm aa"
        required={!!required}
      />
    )) ||
    (element === 'date' && (
      <DatePicker
        selected={value ? new Date(value) : startDate}
        onChange={onChange}
        dateFormat="MMMM d, yyyy"
        required={!!required}
      />
    )) ||
    (type === 'checkbox' && (
      <input
        type={type}
        id={id}
        key={id}
        value={value}
        placeholder={placeholder}
        onClick={onChange}
        className={className}
        required={!!required}
        disabled={isDisabled}
        onFocus={onFocus}
        onBlur={onFocusOut}
        defaultChecked={typeof value === 'boolean' ? value : value === 'true'}
      />
    )) ||
    (type === 'button' && (
      <button
        id={id}
        key={id}
        type="submit"
        disabled={isDisabled}
        className="btn btn-block"
        onClick={onClickWrapperInternal}
        value={value}>
        {title}
      </button>
    )) ||
    // @ts-ignore
    (type !== 'space' && type !== 'object' && (
      <input
        type={type}
        id={id}
        key={id}
        value={type === 'file' ? '' : value}
        placeholder={placeholder}
        onChange={onChange}
        onClick={onClickWrapperInternal}
        className={className}
        required={!!required}
        disabled={isDisabled}
        onFocus={onFocus}
        onBlur={onFocusOut}
        checked={type === 'checkbox' ? value : ''}
      />
    )) ||
    (type === 'object' && (
      <textarea
        id={id}
        key={id}
        value={JSON.stringify(value, undefined, 2)}
        placeholder={placeholder}
        onChange={onChange}
        onClick={onClickWrapperInternal}
        className={className}
        required={!!required}
        disabled={isDisabled}
        onFocus={onFocus}
        onBlur={onFocusOut}
      />
    ));

  // Controls if this input is an entire row to itself or not
  return (
    <div className={rowClassName}>
      <label>{label}</label>

      {formInput}
      <Requirement isHidden={requirementDivIsHidden} text={requirement} />
    </div>
  );
}

export default FormInput;
